import { CoreEnums } from '@/utils/domain/constants';

const { FormFieldStringType, FormFieldType } = CoreEnums;

export const SEPARATORS = [';'];

export const REMOTE_DEFAULT_KEYS = {
  remote: true,
  showSearch: true,
  nomenclature: true,
  allowClear: true,
  lazy: true,
};

export const JSON_DATA_TYPES = [
  FormFieldStringType.SelectorUser,
  FormFieldStringType.SelectorPosition,
  FormFieldStringType.SelectorUserGroup,
  FormFieldStringType.SelectorArea,
  FormFieldStringType.WebServiceRemoteSearch,
  FormFieldStringType.WebServiceRemoteList,
  FormFieldStringType.DataBaseRemoteList,
  FormFieldStringType.DataBaseRemoteSearch,
  FormFieldType.SelectorUser,
  FormFieldType.SelectorPosition,
  FormFieldType.SelectorUserGroup,
  FormFieldType.SelectorArea,
  FormFieldType.WebServiceRemoteSearch,
  FormFieldType.WebServiceRemoteList,
  FormFieldType.DataBaseRemoteList,
  FormFieldType.DataBaseRemoteSearch,
];

export const FIELD_SEARCH_TYPES = [
  FormFieldStringType.WebServiceRemoteSearch,
  FormFieldStringType.DataBaseRemoteSearch,
  FormFieldStringType.FieldDynamicEntitySearch,
  FormFieldType.WebServiceRemoteSearch,
  FormFieldType.DataBaseRemoteSearch,
  FormFieldType.FieldDynamicEntitySearch,
];

export const ROUTES = {
  details: { path: '/applications/:id', exact: true },
  continue: { path: '/applications/continue', exact: false },
  customList: { path: '/custom-lists/view', exact: false },
  dynamicEntity: { path: '/entities/:id', exact: true },
  startProcess: { path: '/processes/start', exact: false },
  externalRequestStart: { path: '/external/request-start/:id', exact: true },
  externalRequestContinue: { path: '/external/request-continue', exact: false },
  versionHistory: { path: '/applications/detailsByActionInstance', exact: false },
};

export const FIELD_TYPE_GROUPS = {
  NUMERIC: [
    FormFieldStringType.Int,
    FormFieldStringType.Int32,
    FormFieldStringType.Decimal,
    FormFieldType.Int,
    FormFieldType.Int32,
    FormFieldType.Decimal,
  ],
  SELECTOR: [
    FormFieldStringType.SelectorUser,
    FormFieldStringType.SelectorPosition,
    FormFieldStringType.SelectorUserGroup,
    FormFieldStringType.SelectorArea,
    FormFieldType.SelectorUser,
    FormFieldType.SelectorPosition,
    FormFieldType.SelectorUserGroup,
    FormFieldType.SelectorArea,
  ],
  REMOTE: [
    FormFieldStringType.WebServiceRemoteSearch,
    FormFieldStringType.WebServiceRemoteList,
    FormFieldStringType.FieldDynamicEntityList,
    FormFieldStringType.DataBaseRemoteList,
    FormFieldStringType.DataBaseRemoteSearch,
    FormFieldStringType.FieldDynamicEntitySearch,
    FormFieldType.WebServiceRemoteSearch,
    FormFieldType.WebServiceRemoteList,
    FormFieldType.FieldDynamicEntityList,
    FormFieldType.DataBaseRemoteList,
    FormFieldType.DataBaseRemoteSearch,
    FormFieldType.FieldDynamicEntitySearch,
  ],
  CHOICE: [FormFieldStringType.Choice, FormFieldType.Choice],
  DATE_TIME: [
    FormFieldStringType.Time,
    FormFieldStringType.DateTime,
    FormFieldStringType.Date,
    FormFieldType.Time,
    FormFieldType.DateTime,
    FormFieldType.Date,
  ],
  ATTACHMENT: [
    FormFieldStringType.Image,
    FormFieldStringType.Photo,
    FormFieldStringType.Signature,
    FormFieldStringType.Attachment,
    FormFieldType.Image,
    FormFieldType.Photo,
    FormFieldType.Signature,
    FormFieldType.Attachment,
  ],
  TEXT: [
    FormFieldStringType.Text,
    FormFieldStringType.TextMultiple,
    FormFieldType.Text,
    FormFieldType.TextMultiple,
  ],
  BOOLEAN: [FormFieldStringType.Boolean, FormFieldType.Boolean],
  SPECIAL: [
    FormFieldStringType.LikertScale,
    FormFieldType.LikertScale,
    FormFieldStringType.GoToAction,
    FormFieldType.GoToAction,
    FormFieldStringType.Location,
    FormFieldType.Location,
    FormFieldStringType.CheckGroup,
    FormFieldStringType.RadioGroup,
    FormFieldType.CheckGroup,
    FormFieldType.RadioGroup,
    FormFieldStringType.CalculatedByFormula,
    FormFieldType.CalculatedByFormula,
    FormFieldStringType.AutoCalculatedByTableColumn,
    FormFieldType.AutoCalculatedByTableColumn,
    FormFieldStringType.Table,
    FormFieldType.Table,
    FormFieldStringType.Slider,
    FormFieldType.Slider,
    FormFieldStringType.Url,
    FormFieldType.Url,
    FormFieldStringType.Email,
    FormFieldType.Email,
    FormFieldStringType.Password,
    FormFieldType.Password,
  ],
};
